import { Flex } from '@chakra-ui/react'
import { ExternalPdfTemplateToolbar } from '../../RichText/TemplateToolbar'

export const ExternalPdfAddField = () => (
  <Flex w="100%" flexFlow="column">
    <ExternalPdfTemplateToolbar />
  </Flex>
)
